import { Dip, Trigger } from "interfaces";

export const DIPS_IMAGE_VARIANT_TAG = "{dips_image_variant}";

export const getClassNameVariant = (buttonsLength: number): string => {
	switch (buttonsLength) {
		case 1:
			return "one-item";
		case 2:
			return "two-items";
		default:
			return "several-items";
	}
};

export const dispatchLogOut = (activeDip: Dip): boolean => {
	const { triggerType } = activeDip.dip;
	return triggerType === "scopelyLogout" || triggerType === "facebookLogout";
};

export type DipAnalyticsType =
	| "limited_deal_hud"
	| "limited_deal_shop"
	| "limited_deal_vip_shop"
	| "auto_popup";

export const getDipAnalyticsType = ({
	fromHud,
	activeTrigger,
	pathname,
	shopPath,
	eliteDealsPath
}: {
	fromHud: boolean;
	activeTrigger?: Trigger;
	pathname: string;
	shopPath: string;
	eliteDealsPath: string;
}): DipAnalyticsType => {
	if (fromHud) {
		return "limited_deal_hud";
	}

	if (activeTrigger === "mainShop") {
		if (pathname === eliteDealsPath) {
			return "limited_deal_vip_shop";
		}
		if (pathname === shopPath) {
			return "limited_deal_shop";
		}
	}

	return "auto_popup";
};

/* TP-26267 Close Click Tracking */
/* eslint-disable */
export const getCloseClickTrackingParams = (
	dipId?: string,
	buttons: any[] = []
) => {
	const purchase: any = [];
	buttons.map((button: any) => {
		const { loyaltyOfferId, offerId, rewardId } = button;
		const buttonTrackingItem: any = {};
		if (loyaltyOfferId) {
			buttonTrackingItem.loyaltyOfferId = loyaltyOfferId;
		}
		if (offerId) {
			buttonTrackingItem.offerId = offerId;
		}
		if (rewardId) {
			buttonTrackingItem.rewardId = rewardId;
		}
		purchase.push(buttonTrackingItem);
	});

	return {
		dip_id: dipId,
		purchase,
		page_location: location.pathname
	};
};
/* eslint-enable */
